import React from 'react';
import cls from '../bottombar.module.scss';
import { Button, Icon } from 'lb-components';
import { BalanceIcon } from '../../../assets/icons';
import { UseUser } from 'lb-store/src/hooks';

const BalanceComponent = ({ setRoute, navigate, t, lang }) => {
  const { User } = UseUser();
  return (
    <div className={cls.balance}>
      <div className={cls.start}>
        <p>{t('ბალანსი')}</p>
        <span>
          {User.balance.balance}
          <sup>₾</sup>
        </span>
      </div>
      <div
        className={cls.center}
        onClick={() => navigate(`${lang}/page/betmarket`)}
      >
        <p>{t('ბეთმარკეტი')}</p>
        <span>{User.balance.points}</span>
      </div>
      <div className={cls.end}>
        <Button
          variant='success'
          style={{
            display: 'flex',
            fontSize: '2rem',
            justifyContent: 'center',
            alignItems: 'center',
            padding: '1.2rem',
          }}
          onClick={() => setRoute('deposit')}
        >
          <Icon Icon={BalanceIcon} width={'2rem'} height={'2rem'} /> &nbsp;
          {t('შევსება')}
        </Button>
      </div>
    </div>
  );
};
export default BalanceComponent;
